import { render, staticRenderFns } from "./popupDisplay.vue?vue&type=template&id=38cdd520&scoped=true&"
import script from "./popupDisplay.vue?vue&type=script&lang=ts&"
export * from "./popupDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./popupDisplay.vue?vue&type=style&index=0&id=38cdd520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cdd520",
  null
  
)

component.options.__file = "popupDisplay.vue"
export default component.exports